import React, { useMemo } from "react";
import dayjs from "dayjs";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

/** X축: 매월 1일만 `N월`, 그 외는 일(숫자)만 */
function formatAxisLabel(isoDate) {
  const d = dayjs(isoDate);
  if (!d.isValid()) return "";
  if (d.date() === 1) {
    return `${d.month() + 1}월 1일`;
  }
  return String(d.date());
}

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  plugins: {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
  },
  responsive: true,
  interaction: {
    mode: true,
    intersect: false,
  },
  scales: {
    x: {
      stacked: true,
      ticks: {
        fontSize: 1,
      },
    },
    y: {
      stacked: true,
      title: {
        display: true,
        text: "(원)",
      },
      ticks: {
        fontSize: 10,
      },
    },
  },
};

export default function DashboardMap({ chartData = [] }) {
  const chartConfig = useMemo(() => {
    const labels = chartData.map((row) => formatAxisLabel(row.date));
    const values = chartData.map((row) => Number(row.totalSales) || 0);
    return {
      labels,
      datasets: [
        {
          label: "매출",
          data: values,
          backgroundColor: "#f2dca8",
        },
      ],
    };
  }, [chartData]);

  return (
    <div className="shadow-dashboard p-4">
      <Bar width={200} height={50} options={options} data={chartConfig} />
    </div>
  );
}
